import { addHours, differenceInSeconds, set } from 'date-fns';
import { useState } from 'react';
import { useInterval } from 'usehooks-ts';

const DELAY = 1000;
const formatCountdown = (minutes: number, seconds: number): string => {
  return `${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
};
export const useFundingCountdown = (lastUpdatedMs: number | undefined) => {
  const lastUpdated = lastUpdatedMs ? new Date(lastUpdatedMs) : undefined;
  const [now, setNow] = useState(Date.now());

  useInterval(() => {
    setNow(Date.now());
  }, DELAY);

  // Calculate current hour timestamp
  const currentHour = set(new Date(now), { minutes: 0, seconds: 0, milliseconds: 0 });

  // Calculate next hour timestamp
  const nextHour = set(addHours(now, 1), { minutes: 0, seconds: 0, milliseconds: 0 });

  // Get difference in seconds from current hour
  const secondsSinceHour = differenceInSeconds(new Date(now), currentHour);

  // Get difference in seconds to next hour
  const diffInSeconds = differenceInSeconds(nextHour, now);

  // Calculate minutes and seconds
  const minutes = Math.floor(diffInSeconds / 60);
  const seconds = diffInSeconds % 60;

  // If we have no funding updates at all -> count down to next hour
  if (!lastUpdated) {
    return {
      minutes,
      seconds,
      formatted: formatCountdown(minutes, seconds),
    };
  }

  // If funding update is from the current hour -> count down to next hour
  if (lastUpdated >= currentHour) {
    return {
      minutes,
      seconds,
      formatted: formatCountdown(minutes, seconds),
    };
  }

  // Funding update is from previous hour
  // If within first 15 seconds -> return 0
  // If past 15 seconds -> count down to next hour
  if (secondsSinceHour <= 15) {
    return { minutes: 0, seconds: 0, formatted: formatCountdown(0, 0) };
  }

  return {
    minutes,
    seconds,
    formatted: formatCountdown(minutes, seconds),
  };
};
